/* eslint-disable no-param-reassign */
import m from "mithril";
import moment from "moment";
import header from "../../components/header";
import toolbar from "../../components/toolbar"
import sidebar from "../../components/sidebar"
import table_data from "../../components/table_data"
import graph from "./components/graph";
import multiSelect from "../../components/bootstrap-select";
import companyBannner from "../../components/companyBannner";
import { runQuery, headers } from "../../utils/fetchData";
import timePicker from "../../components/timePicker";
import htmlEditor from "../../components/htmlEditor";
import config from "../../config";
import stats from "./components/stats";
import map from "./components/google-maps";
import tmpMap from "./components/tmpMap";
import tutorials from "./components/tutorials";
import commonQuestions from "./components/commonQuestions";
import dataMap from "../../utils/data";

import { t, setSelectedLanguage } from '../../translation-files/translator'

import addTutorials from "./modals/add"
import main from "../../../oldSystsemWrap/index"


function getNumberWithOrdinal(i) {
  const j = i % 10;

  const k = i % 100;
  if (j === 1 && k !== 11) {
    return `${i}st`;
  }
  if (j === 2 && k !== 12) {
    return `${i}nd`;
  }
  if (j === 3 && k !== 13) {
    return "rd";
  }
  return `${i}th`;
}

export default {
  oncreate() {
    window.KTComponents.init()
  },
  async oninit({ state, attrs }) {

    // main().then(console.log)


    state.logos = {
dark: "assets/media/logos/bill-logo.svg",
          light: "assets/media/logos/bill-logo.svg"
    }

    state.authenticate = async ({ usertype, username, password }) => {
      m.route.set('/dashboard')
      return;
      const headers = {
        'Content-Type': 'application/x-www-form-urlencoded',
      };

      const data = {
        'struts.token.name': 'struts.token',
        'struts.token': 'LW04VBWLG016PSXGQR2KM3DHLOLKB0AX',
        usertype,
        username,
        password
      };

      try {
        const response = await m.request({
          method: 'POST',
          headers: {
            'Accept': 'text/html,application/xhtml+xml,application/xml;q=0.9,image/avif,image/webp,image/apng,*/*;q=0.8,application/signed-exchange;v=b3;q=0.7',
            'Accept-Language': 'en-US,en;q=0.9,zh-CN;q=0.8,zh;q=0.7,fr;q=0.6,ar;q=0.5',
            'Cache-Control': 'no-cache',
            'Connection': 'keep-alive',
            'Content-Type': 'application/x-www-form-urlencoded',
          },
          url: 'http://localhost:3000/kkportal/validateUserLoginAction.do',
          data: Object.keys(data).map(key => `${key}=${data[key]}`).join('&')
        })
        // Get the JSESSIONID cookie from the response
        const cookies = response.headers['set-cookie'];
        const jsessionIdCookie = cookies.find(cookie => cookie.includes('JSESSIONID'));
        const jsessionId = jsessionIdCookie.split('=')[1].trim();

        // Store the JSESSIONID cookie securely
        setState({ jsessionId });

        // Use the JSESSIONID cookie for all subsequent requests
        headers['Cookie'] = `JSESSIONID=${jsessionId}`;

        // Handle the response body
        // const responseBody = await response.json();
        // Do something with the response body

      } catch (err) {
        console.error(err);
      }
    };

    Object.assign(state, {
      selectedTeams: [],
      selectedUsers: [],
      selectedProjects: [],
      teams: [],
      users: [],
      projects: [],
      projectsT: true,
      teamsT: false,
      usersT: false,
      fetching: false,
      selectedTime: {
        end: moment(new Date()),
        start: moment(new Date())
          .subtract(6, "day")
          .startOf("day")
      },
      data: [],
      labels: [],
      stats: {},
      gpsData: []
    });

    state.fetchResults = async clientId => {
      const { start, end } = state.selectedTime;

      state.fetching = true;
      m.redraw();

      try {
        const results = await m.request({
          method: "POST",
          headers: headers(),
          url: `${config[window.env].apiUrl}/submision/breakDayDown/${new Date(
            start
          ).toISOString()}/${new Date(end).toISOString()}`,
          data: Object.assign(
            {
              client: clientId
            },
            state.teamsT === true
              ? { teamId: { $in: state.selectedTeams } }
              : {},
            state.projectsT === true
              ? { projectId: { $in: state.selectedProjects } }
              : {},
            state.usersT === true
              ? { userId: { $in: state.selectedUsers } }
              : {}
          )
        });

        Object.assign(state, {
          fetching: false,
          data: [],
          labels: []
        });
        m.redraw();

        const labels = Object.values(results)
          .reverse()
          .map(
            ({ start }) =>
              `${getNumberWithOrdinal(moment(start).format("DD"))}-${moment(
                start
              ).format("MM")}`
          );

        const data = Object.values(results)
          .reverse()
          .map(({ count }) => count);

        const gpsData = Object.values(results)
          .reverse()
          .map(({ data }) => data);

        Object.assign(state, {
          data,
          labels,
          gpsData
        });

        m.redraw();
      } catch (err) {
        Object.assign(state, {
          fetching: false
        });
        m.redraw();
      }
    };

    state.resetSelections = () => {
      Object.assign(state, {
        selectedTeams: [],
        selectedUsers: [],
        selectedProjects: [],
        teams: [],
        users: [],
        projects: [],
        projectsT: true,
        teamsT: false,
        usersT: false,
        selectedTime: {
          end: moment(new Date()),
          start: moment(new Date())
            .subtract(6, "day")
            .startOf("day")
        },
        fetching: false,
        data: [],
        labels: []
      });

      m.redraw();
    };

    const {
      users,
      id: clientId,
      stats,
      teams,
      projects
    } = await dataMap.getClientData();

    Object.assign(state, {
      projects,
      teams,
      users,
      stats,
      clientId,
      selectedTeams: [...teams.map(p => p.id)],
      selectedUsers: [...users.map(p => p.id)],
      selectedProjects: [...projects.map(p => p.id)]
    });

    state.fetchResults(clientId);


    m.redraw();
  },
  // disable due to failures on some browsers
  oncreate() {
    document.body.className = '';
    document.body.style.backgroundImage = "url('assets/media/illustrations/rubis-auth-background.png')";
    document.body.style.backgroundSize = "cover";
    document.body.style.backgroundRepeat = "no-repeat";
    document.body.style.backgroundPosition = "center";
    document.body.style.display = 'flex';
    document.body.style.alignItems = 'center';
    document.body.style.justifyContent = 'center';
    document.querySelector('.app-page').style.display = 'flex';

    // center in page vertically
    document.querySelector('.app-page').style.justifyContent = 'center';
    document.getElementById('kt_app_root').style.paddingLeft = '70%';
    document.getElementById('kt_app_root').style.paddingTop = '5%';

    const appDiv = document.getElementById('app');
    if (appDiv) {
      appDiv.style.width = '450px';
      appDiv.style.minWidth = '450px';
      appDiv.style.maxWidth = '450px';
    }

    document.body.style.backgroundSize = "105vw"; // set background size to 100% of viewport width
    document.body.style.backgroundPosition = "center -13vw"; // adjust the vertical position of the background image
  },
  onremove() {
    document.body.className = '';
    document.body.style.backgroundImage = '';
    document.body.style.backgroundSize = '';
    document.body.style.backgroundRepeat = '';
    document.body.style.backgroundPosition = '';
    document.body.style.display = '';
    document.body.style.alignItems = '';
    document.body.style.justifyContent = '';

    document.querySelector('.app-page').style.display = '';
    document.querySelector('.app-page').style.justifyContent = '';

    document.getElementById('kt_app_root').style.paddingLeft = '';
    document.getElementById('kt_app_root').style.paddingTop = '';

    const appDiv = document.getElementById('app');
    if (appDiv) {
      appDiv.style.width = '';
      appDiv.style.minWidth = '';
      appDiv.style.maxWidth = '';
    }
  },
  view({ state, attrs }) {
    return [
      m("div", {
        "class": "d-flex align-items-center justify-content-center flex-column"
      },
        m("div", { "class": "card shadow-sm" },
          [
            m("div", { "class": "card-body" }, [
              // m("iframe", { "src": "http://localhost:3000/kkportal/loginLink.do", "width": "100%", "height": "500", "frameBorder": "0" }),

              m("label", {
                "class": "card-title text-center", "style": {
                  "font-size": "2rem",
                  "font-weight": "850",
                  "display": "block",
                  "text-align": "center"
                }
              },
                t().auth_login.login.label
              ),
              m("label", { "class": "card-title text-center", "style": { "font-size": "1.5rem" } },
                m("span", {
                  "class": "text-truncate",
                  "style": {
                    "text-overflow": "ellipsis",
                    "overflow": "hidden",
                    "white-space": "wrap",
                    "max-width": "100px" // adjust the width to change the truncation limit
                  }
                },
                  t().auth_login.login.sublabel
                )
              ),

              m("div", { "class": "mb-10" }, [
                m("label", { "class": "required form-label", "for": "exampleFormControlInput1" },
                  t().auth_login.login.account_type.label
                ),
                m("select", {
                  "class": "form-select", "aria-label": "Select example", "onchange": (e) => {
                    state.selectedAccountType = e.target.value;
                    m.redraw();
                  }, "value": state.selectedAccountType
                },
                  [
                    m("option",
                      t().auth_login.login.account_type.placeholder
                    ),
                    ["Bill Staff",
                      "Institution",
                      "Corporate"].map(type => {
                        return m("option", { "value": type },
                          type
                        )
                      })
                  ]
                )
              ]
              ),

              m("form", { "class": "form w-100 fv-plugins-bootstrap5 fv-plugins-framework", "novalidate": "novalidate", "id": "kt_sign_in_form", "data-kt-redirect-url": "/keen/demo7/index.html", "action": "#" },
                [
                  m("div", { "class": "mb-10" },
                    [
                      m("label", { "class": "required form-label", "for": "exampleFormControlInput1" },
                        t().auth_login.login.username.label
                      ),
                      m("input", {
                        "class": "form-control",
                        "type": "email",
                        "placeholder": t().auth_login.login.username.placeholder,
                        "value": state.username,
                        "oninput": (e) => state.username = e.target.value
                      })
                    ]
                  ),
                  m("div", { "class": "mb-10" },
                    [
                      m("label", { "class": "required form-label", "for": "exampleFormControlInput1" },
                        t().auth_login.login.password.label
                      ),
                      m("input", {
                        "class": "form-control",
                        "type": "password",
                        "placeholder": t().auth_login.login.password.placeholder,
                        "value": state.password,
                        "oninput": (e) => state.password = e.target.value
                      })
                    ]
                  ),
                  m("div", { "class": "d-flex flex-stack flex-wrap gap-3 fs-base fw-semibold mb-8" },
                    [
                      m("div"),
                      m("a", { "class": "link-primary", "href": "/" },
                        t().auth_login.login.forgot_pass_text
                      )
                    ]
                  ),

                  m("div", { "class": "d-grid mb-10" },
                    m("button", {
                      "class": "btn btn-primary",
                      "type": "submit",
                      "id": "kt_sign_in_submit",
                      onclick(e) {
                        e.preventDefault();

                        const { password, username, selectedAccountType: usertype } = state

                        // state.authenticate({
                        //   password, username, usertype
                        // })

                        m.route.set("/dashboard")
                        localStorage.setItem('hasAuthenticated', 'true')
                        localStorage.setItem('authenticationTime', new Date().getTime())
                        location.reload()
                      }
                    },
                      [
                        m("span", { "class": "indicator-label" },
                          t().auth_login.login.login_button_text
                        ),
                        m("span", { "class": "indicator-progress" },
                          [
                            " Please wait... ",
                            m("span", { "class": "spinner-border spinner-border-sm align-middle ms-2" })
                          ]
                        )
                      ]
                    )
                  ),
                  m("div", { "class": "text-gray-500 text-center fw-semibold fs-6" },
                    [
                      t().auth_login.login.quick_actions_text,
                    ]
                  ),
                  m("div", { "class": "text-gray-500 text-center fw-semibold fs-6" },
                    [

                      m("a", { "class": "link-primary", "href": "/" },
                        t().auth_login.login.card_text
                      )
                    ]
                  ),
                  m("div", { "class": "text-gray-500 text-center fw-semibold fs-6" },
                    [
                      m("a", { "class": "link-primary", "href": "/" },
                        t().auth_login.login.activate_card_text
                      )
                    ]
                  ),
                  m("div", { "class": "text-gray-500 text-center fw-semibold fs-6" },
                    [
                      m("a", { "class": "link-primary", "href": "/" },
                        t().auth_login.login.contact_us_text
                      )
                    ]
                  ),

                  m("div", { "class": "mb-10" }, [
                    // m("label", { "class": "required form-label", "for": "exampleFormControlInput1" },
                    //   "Language" // added label
                    // ),
                    m("select", {
                      "class": "form-select form-select-transparent",
                      "style": { "maxWidth": "120px", "width": "100%", "margin": "0 auto", "display": "block" },
                      "aria-label": "Select language",
                      "onchange": (e) => {
                        localStorage.setItem('langCode', e.target.value);
                        setSelectedLanguage(e.target.value);
                        location.reload();
                      },
                      "value": localStorage.getItem('langCode') || "en" // default to "en" if not found in localStorage
                    },
                      [
                        m("option", { "value": "en" }, "English"),
                        // m("option", { "value": "fr" }, "French")
                      ])
                  ])

                ]
              )
            ]),

          ]
        )
      )
    ];
  }
};
